import AppRuntimeEnv from "@/types/AppRuntimeEnv";
import { lang } from "../../context";
import { pageTypes } from "../../api/createmenu";
import { createDocumentByPageType } from "./utils";
import { message } from "antd";

interface IProps {
  title?: string;
  type: string;
  successCallBack?: Function;
  failCallBack?: Function;
  appRuntimeEnv: AppRuntimeEnv;
}

export function createDocument(props: IProps) {
  const { type, successCallBack, failCallBack, appRuntimeEnv } = props;
  const urlPrefix = appRuntimeEnv.joyspaceHost;
  createDocumentByPageType(type, "", "")
    .then((res: any) => {
      if (!res) return;
      const openUrl = `${urlPrefix}/${pageTypes[res.page_type]}/${res.id}`;
      window.open(openUrl);
      successCallBack?.(res);
    })
    .catch((err: any) => {
      message.error(lang("common.fail"));
      failCallBack?.();
    });
}
